import { FC } from "react";
import {
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
  MDSRowItem,
  MDSRowItemAppearance,
  MDSRowItemSlotName,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import styled from "@emotion/styled";
import { pluralize } from "@/modules/pluralize";

export interface NoUpcomingMeetingsContentViewProps {
  cutoffDayName: string;
  connectedCalendarsCount: number;
  onClick: () => void;
}

export const NoUpcomingMeetingsContentView: FC<NoUpcomingMeetingsContentViewProps> = ({
  cutoffDayName,
  connectedCalendarsCount,
  onClick,
}) => {
  return (
    <MDSRowItem
      $isSelected={false}
      $isHighlighted={false}
      $isSpecial={false}
      $mustClickOnRowTitle={false}
      $appearance={MDSRowItemAppearance.Standard}
      onClick={onClick}
    >
      <StyledIconWrapper slot={MDSRowItemSlotName.LeftAddon}>
        <MDSIcon size={18} kind={MDSIconKind.CalendarCheck} color={MDSIconColor.Placeholder} />
      </StyledIconWrapper>

      <ContentRow>
        <Content>
          <LabelContainer>
            <MDSText
              variant={MDSTextVariant.TextM}
              weight={MDSTextWeight.Medium}
              color={MDSTextColor.Tertiary}
            >
              No meetings through {cutoffDayName}
            </MDSText>
          </LabelContainer>
        </Content>
      </ContentRow>

      <BottomRow slot={MDSRowItemSlotName.BottomAddon}>
        <MDSText variant={MDSTextVariant.TextS} color={MDSTextColor.Tertiary}>
          Based on {connectedCalendarsCount} connected{" "}
          {pluralize(connectedCalendarsCount, "calendar", "calendars")}
        </MDSText>
      </BottomRow>
    </MDSRowItem>
  );
};

const ContentRow = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-shrink: 1;
`;

const Content = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const LabelContainer = styled.div`
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

const StyledIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  min-width: fit-content;
  align-self: stretch;
  padding-right: ${({ theme }) => theme.spacing["3"]};
  padding-top: 6px;
`;
